import React, { useState, useEffect } from "react";

const CheckCounter = ({ initialTimeProp = 60 }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialTimeProp);

  useEffect(() => {
    let endTime = localStorage.getItem("countdownEndTime");

    if (
      !endTime ||
      localStorage.getItem("lastInitialTime") !== String(initialTimeProp)
    ) {
      // If there is no saved end time OR initialTimeProp has changed, reset the countdown
      endTime = Date.now() + initialTimeProp * 1000;
      localStorage.setItem("countdownEndTime", endTime);
      localStorage.setItem("lastInitialTime", String(initialTimeProp));
    } else {
      endTime = parseInt(endTime, 10);
    }

    const updateCountdown = () => {
      const remainingTime = Math.max(
        Math.floor((endTime - Date.now()) / 1000),
        0
      );
      setSecondsLeft(remainingTime);

      if (remainingTime > 0) {
        requestAnimationFrame(updateCountdown);
      }
    };

    updateCountdown();

    return () => cancelAnimationFrame(updateCountdown);
  }, [initialTimeProp]); // Depend on prop change

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  return (
    <div>
      <h1>Countdown Timer</h1>
      <p>Time Left: {formatTime(secondsLeft)}</p>
    </div>
  );
};

export default CheckCounter;
